/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const Tabs = {

	$domTabPill: $('.js-tab-pill'),
	$domTabBody: $('.js-tab'),
	classActive: 'is-active',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domTabPill.on('click', this.showTab);
	},

	showTab: function() {
		const tabId = $(this).data('tab');
		const $tab = $(`#tab-${tabId}`);

		Tabs.hideTabs();
		$(this).addClass(Tabs.classActive);
		$tab.addClass(Tabs.classActive);
	},

	hideTabs: function() {
		this.$domTabPill.removeClass(this.classActive);
		this.$domTabBody.removeClass(this.classActive);
	}
};

export default Tabs;
